import { v1ApiClient } from '@/services';

export const getChart = async (alias: string): Promise<ChartItem> => {
  const res = await v1ApiClient.get<ChartItem>(`/charts/${alias}`);
  return res.data;
};
